export default __webpack_public_path__ + "static/media/spinner.e94752fe.gif";